import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { StyledListboxList, useListboxContext } from '@frontend/design-system';

type ContentProps = {
  children: ReactNode;
};

export const DefaultViewContent = ({ children }: ContentProps) => {
  const { listboxProps } = useListboxContext();

  return (
    <StyledListboxList {...listboxProps} css={contentStyles}>
      {children}
    </StyledListboxList>
  );
};

const contentStyles = css({
  flex: 1,
  overflow: 'auto',
  padding: theme.spacing(1, 0),
});
